export const devLog = (...args: Parameters<typeof console.log>) => {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }
  // eslint-disable-next-line no-console
  console.log(...args);
};
